// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2E8sW","modalFooterButton":"ModalNotes_modalFooterButton__3JOQ1"};